export default "/_next/static/images/background-180c092c25e797a5bf704e4ce0125b64.png";